import { Scenario } from './fact';

export enum NRPMode {
  cost_of_equity = 'cost_of_equity',
  direct_wacc_overlay = 'direct_wacc_overlay',
}

export type ScenarioSettingsRequestBody = {
  biophysical_horizon?: number;
  climate_scenario?: Scenario;
  nrp_mode?: NRPMode;
};

export type NRPDependency = {
  vulnerability: number;
  physical_stress: number;
  interaction: number;
};

export type TrajectoryRow = {
  t: number;
  calendar_year: number;
  hazard: number;
  exposure: number;
  eii: number;
  vulnerability: number;
  vulnerability_weight_coeff: number;
  physical_stress_weight_coeff: number;
  interaction_weight_coeff: number;
  nrp_cost_of_equity: number;
  wacc: number;
  dependency: NRPDependency;
};

export type ClimateDriverRow = {
  t: number;
  calendar_year: number;
  hazard: number;
};

export type ValuationState = {
  label: string;
  description: string;
  enterprise_value: number;
  equity_value: number;
  delta_from_prior: number;
};

export type BridgeItem = {
  item: string;
  amount: number;
  definition: string;
  interpretation: string;
};

export type RateDecompositionRow = {
  state: string;
  nrp_coe: number;
  wacc: number;
  ev: number;
};

export type ScenarioComparisonEntry = {
  ev: number;
  nrp_post_y10: number;
  wacc_y10: number;
  nominal_cost: number;
  pv_cost: number;
  gross_benefit: number;
  net_benefit: number;
};

export type ScenarioComparisonTable = {
  nrp_pre_intervention: number;
  opacity_penalty: number;
  transparency_benefit: number;
  scenarios: Record<string, ScenarioComparisonEntry>;
};

/**
 * POST /api/v1/scenario-forecast/organization/{organization_id}/physical-risk/
 */
export const POST_ORGANIZATION_PHYSICAL_RISK_PATH = 'scenario-forecast/organization/{organization_id}/physical-risk/';
export type PostOrganizationPhysicalRiskPathVariables = { organization_id: string };
export type PostOrganizationPhysicalRiskQueryParams = undefined;
export type PostOrganizationPhysicalRiskRequestBody = {
  scenario_settings?: ScenarioSettingsRequestBody;
  is_demo?: boolean;
};
export type PostOrganizationPhysicalRiskSuccessDto = {
  baseline: TrajectoryRow[];
  recommended: TrajectoryRow[];
  high_ambition: TrajectoryRow[];
  climate_drivers: ClimateDriverRow[];
};
export type PostOrganizationPhysicalRiskErrorDto = Error;

/**
 * POST /api/v1/scenario-forecast/organization/{organization_id}/financial-impact/
 */
export const POST_ORGANIZATION_FINANCIAL_IMPACT_PATH =
  'scenario-forecast/organization/{organization_id}/financial-impact/';
export type PostOrganizationFinancialImpactPathVariables = { organization_id: string };
export type PostOrganizationFinancialImpactRequestBody = {
  scenario_settings?: ScenarioSettingsRequestBody;
  is_demo?: boolean;
};
export type PostOrganizationFinancialImpactSuccessDto = {
  valuation_states: ValuationState[];
  bridge: BridgeItem[];
  rate_decomposition: RateDecompositionRow[];
  scenario_comparison: ScenarioComparisonTable;
};
export type PostOrganizationFinancialImpactErrorDto = Error;
